import { render, staticRenderFns } from "./CampaignCardFullView.vue?vue&type=template&id=fd0850c0&scoped=true&"
import script from "./CampaignCardFullView.vue?vue&type=script&lang=js&"
export * from "./CampaignCardFullView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCardFullView.vue?vue&type=style&index=0&id=fd0850c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0850c0",
  null
  
)

export default component.exports